'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" fillRule="evenodd" d="M12 18c-3.67 0-7.046-2.288-8.97-6C4.955 8.288 8.33 6 12 6s7.046 2.288 8.97 6c-1.924 3.712-5.3 6-8.97 6M1.189 12.792a1.75 1.75 0 0 1 0-1.584C3.374 6.894 7.398 4 12 4s8.626 2.894 10.81 7.208a1.75 1.75 0 0 1 0 1.584C20.627 17.107 16.603 20 12 20s-8.626-2.893-10.811-7.208M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0m2 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0" clipRule="evenodd" /></svg>;
const IconVisibility = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconVisibility;